import { render } from "./IsoVoyageTurkey.vue?vue&type=template&id=1ca3a39e"
import script from "./IsoVoyageTurkey.vue?vue&type=script&lang=js"
export * from "./IsoVoyageTurkey.vue?vue&type=script&lang=js"

import exportComponent from "/home/ammar/Downloads/inso_app/isoassurance/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__